import {Injectable, inject} from '@angular/core';
import {DotLazyPhraseService} from '@ng-dot/text';
import {ListAdjust} from '@ng-dot/ux/list';
import {TextService} from './text.service';

/**
 * 별도 JSON 파일로부터 출력 문구를 불러들여 운영 합니다.
 */
@Injectable({
	providedIn: 'any'
})
export class LazyPhraseService<TTokens extends string> extends DotLazyPhraseService<TTokens> {
	protected _text = inject(TextService);

	load(...ids: string[]){
		return super.load('global-model', ...ids);
	}

	select(target, id) {
		return this._text.select(target, id);
	}

	/**
	 * 데이터테이블 조정, 번역열 연동
	 *
	 * @example 번역 설정
	 * ```ts
	 * class {
	 *     listAdjusts = [
	 *         this._text.listTarget('name')
	 *     ]
	 * }
	 * ```
	 * @param target
	 */
	listTarget(target: string, description?) {
		const adjust: ListAdjust<any> = {
			value: {
				target,
				replace: (value, values) => this._text.select(values, target)
			}
		}
		if (description) {
			adjust.description = {
				target: description,
				replace: (value, values) => this._text.select(values, description)
			}
		}
		return adjust;
	}
}